import React, { useEffect } from 'react'
import { useField } from 'formik'
import { FieldComponent } from 'components/Shared/FieldComponent'
import { ContainerColumn } from '../ContainerColumn'
import { ContainerRow } from '../ContainerRow'
import { ContractorAndFerryServiceSelectField } from './ContractorAndFerryServiceSelectField'
import styles
  from 'components/Order/OrderForms/OrderForm/OrderTransactionsForm/OrderTransactionsGroupForm/OrderTransactionForm/OrderTransaction.module.css'
import { CurrencySelectField } from 'components/Shared/CurrencySelectField'

export function FerryPassageForm ({ name, onFerryPassageChanged, disabled }) {
  const [, meta] = useField(name)
  const { value } = meta

  const isFerryServiceNotSelected = !value.ferryServiceId

  useEffect(() => {
    const { contractorId, price, paymentDays } = value
    onFerryPassageChanged({ contractorId, price, paymentDays })
  }, [value, onFerryPassageChanged])

  return (
    <>
      <ContainerColumn>
        <ContractorAndFerryServiceSelectField
          name={name}
          disabled={disabled}
        />
        <FieldComponent
          fieldName={`${name}.harbourCoordinates`}
          label="form.order.cargo.ferryPassage.harbourCoordinates"
          disabled={disabled || isFerryServiceNotSelected}
          required
        />
      </ContainerColumn>
      <ContainerColumn>
        <ContainerRow>
          <FieldComponent
            fieldName={`${name}.price.amount`}
            label="form.order.cargo.ferryPassage.price.amount"
            type="number"
            disabled={disabled || isFerryServiceNotSelected}
            required
          />
          <div style={{ width: 8 }}/>
          <CurrencySelectField
            fieldName={`${name}.price.currencyCode`}
            label="form.order.cargo.ferryPassage.price.currencyCode"
            disabled={disabled || isFerryServiceNotSelected}
            required
          />
        </ContainerRow>
        <ContainerRow>
          <FieldComponent
            fieldName={`${name}.bunkerAdjustmentFactor.amount`}
            label="form.order.cargo.ferryPassage.bunkerAdjustmentFactor.amount"
            type="number"
            disabled={disabled || isFerryServiceNotSelected}
            required
          />
          <div style={{ width: 8 }}/>
          <CurrencySelectField
            fieldName={`${name}.bunkerAdjustmentFactor.currencyCode`}
            label="form.order.cargo.ferryPassage.bunkerAdjustmentFactor.currencyCode"
            disabled={disabled || isFerryServiceNotSelected}
            required
          />
        </ContainerRow>
        <FieldComponent
          label={'form.order.transaction.paymentDays'}
          fieldName={`${name}.paymentDays`}
          type="number"
          className={styles.paymentDateField}
          disabled={disabled}
        />
        <FieldComponent
          fieldName={`${name}.additionalInfo`}
          label="form.order.cargo.ferryPassage.additionalInfo"
          disabled={disabled || isFerryServiceNotSelected}/>
      </ContainerColumn>
    </>
  )
}
